// import React, { Fragment, useState, useEffect } from "react";
// import { axiosClient } from "../../../utils/auth.util";
// import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
// /*------ Pages-----*/
// import Header from "../Components/dashboard-navbar";
// import TutorExam from "../Pages/tutor_exam/TutorExam";
// import TutorExamEntrance from "../Pages/tutor_exam/TutorExamEntrance";
// import TutorExamEnd from "../Pages/tutor_exam/TutorExamEnd";
// import { Puff } from "react-loader-spinner";
// import {
//   setResultData,
//   setSelectedSubject,
//   setExamId,
//   setTutorMark,
//   setExamObj,
// } from "../../../redux/slice/tutorExamSlice";
// import { useDispatch, useSelector } from "react-redux";
// import TutorExamEndDialog from "../Pages/tutor_exam/TutorExamEndDialog";
// import SubjectiveDemo from "../Pages/tutor_exam/SubjectiveDemo.jsx";
// import SubjectiveTestComponent from "../Pages/tutor_exam/TutorTermsAndCondition.jsx";
// import SubjectiveResult from "../Pages/tutor_exam/SubjectiveResult.jsx";

// const TutorExamAppWrapper = () => {
//   const history = useNavigate();
//   const [subList, setSubList] = useState([]);
//   const [selectedSub, setSelectedSub] = useState([]);
//   const [currentBase64, setCurrentBase64] = useState([]);
//   const [keyArSend, setKeyArSend] = useState([]);
//   const [subject, setSubject] = useState();
//   const [resultStatus, setResultStatus] = useState();
//   const [result, setResult] = useState();
//   const [examId, setExamId] = useState();
//   const [tutStatusVal, setTutStatusVal] = useState()
//   const examObj = useSelector((state) => state.exam.examObj);
//   console.log("✌️examObj --->", examObj);
  
//   // Safe localStorage access with fallback
//   const [tutorId, setTutorId] = useState(() => {
//     try {
//       const tutorData = localStorage.getItem("tutor");
//       if (tutorData) {
//         const parsed = JSON.parse(tutorData);
//         return parsed?.saveTutor?.tutor_id || "DEFAULT_TUTOR_ID";
//       }
//       return "DEFAULT_TUTOR_ID";
//     } catch (error) {
//       console.error("Error reading tutor data from localStorage:", error);
//       return "DEFAULT_TUTOR_ID";
//     }
//   });

//   // Create a safe function to get tutor data with proper error handling
//   const getTutorData = () => {
//     try {
//       const tutorData = localStorage.getItem("tutor");
//       if (tutorData) {
//         return JSON.parse(tutorData);
//       }
//       return {
//         tutor_id: "DEFAULT_TUTOR_ID",
//         name: "Test User",
//         email: "",
//         role: "academic",
//         Bank: {
//           acc_no: "",
//           bank_name: "",
//           ifsc_code: "",
//           beneficiary_name: "",
//           upi_id: ""
//         },
//         phone: "",
//         country_code: "+91",
//         highest_degree: "",
//         department: "",
//         subjects: [],
//         software_skills: [],
//         languages: [],
//         qualifications: [],
//         profile_completed: false,
//         status: "active",
//         tutStatus: "db"
//       };
//     } catch (error) {
//       console.error("Error parsing tutor data:", error);
//       return {
//         tutor_id: "DEFAULT_TUTOR_ID",
//         name: "Test User",
//         email: "",
//         role: "academic",
//         Bank: {
//           acc_no: "",
//           bank_name: "",
//           ifsc_code: "",
//           beneficiary_name: "",
//           upi_id: ""
//         },
//         phone: "",
//         country_code: "+91",
//         highest_degree: "",
//         department: "",
//         subjects: [],
//         software_skills: [],
//         languages: [],
//         qualifications: [],
//         profile_completed: false,
//         status: "active",
//         tutStatus: "db"
//       };
//     }
//   };
  
//   const [timeOfTest, setTimeOfTest] = useState();
//   const [tutStatusUpdate, setTutStatusUpdate] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const location = useLocation();

//   console.log(subList, "😏😏😏");

//   const dispatch = useDispatch();

//   var subjectList = [
//     "Soil Mechanics",
//     "Mass Transfer",
//     "Business Math",
//     "Physical chemistry",
//   ];

//   useEffect(() => {
//     const findForm2 = async () => {
//       const find_examId = await axiosClient.post(
//         "/tutorweb/find_examId",
//         {
//           tutorId: tutorId,
//         }
//       );

//       console.log({ debug_tutorId: find_examId });
//       if (find_examId?.data?.success === true) {
//         let exmId = find_examId?.data?.examId?.split("_")[1];
//         let newId = +exmId + 1;
//         let newId2 = tutorId + "_" + newId;
//         let get_subject_updated = [];

//         setTutStatusVal(find_examId.data.tutStatus)
//         const get_subjects = await axiosClient.get(
//           "https://testapis4.el.r.appspot.com/api/tutor/get_subjects"
//         );

//         if (get_subjects) {
//           let retestTrueSubjects = new Set();
//           get_subject_updated = get_subjects?.data?.subVal;

//           //storing subjects with retest true
//           find_examId?.data?.tutor_exam?.forEach((el) => {
//             get_subject_updated?.forEach((el2) => {
//               if (el2[0] === el.subject) {
//                 if (el?.retest === true) {
//                   retestTrueSubjects.add(el.subject);
//                 } else {
//                   retestTrueSubjects.delete(el.subject)
//                 }
//               }
//             });
//           });

//           //filtering already written subjects
//           get_subject_updated = await get_subject_updated?.filter((el2) => {
//             return !find_examId?.data?.tutor_exam.some(
//               (el) => el.subject === el2[0]
//             );
//           });

//           console.log({ retestTrueSubjects, get_subject_updated });
//           //pushing retest true
//           retestTrueSubjects.forEach((eachSub) =>
//             get_subject_updated.push([eachSub])
//           );

//           setSubList(get_subject_updated);
//           setExamId(newId2);
//           setLoading(false);
//         }

//         if (find_examId.data.lastExamId) {
//           if (
//             find_examId.data.tutStatus === "mcqe" &&
//             location.pathname !== "/register-dashboard/tutor_exam/submitted"
//           ) {
//             history("/register-dashboard/tutor_exam/submitted", { replace: true });
//             window.location.reload();
//           } else if (
//             find_examId.data.tutStatus === "subs" &&
//             location.pathname !== "/register-dashboard/tutor_exam/subjective_sheet"
//           ) {
//             history("/register-dashboard/tutor_exam/subjective_sheet", { replace: true });
//             window.location.reload();
//           } else if (
//             find_examId.data.tutStatus === "sube" &&
//             location.pathname !== "/register-dashboard/tutor_exam/subjective_result"
//           ) {
//             history("/register-dashboard/tutor_exam/subjective_result", { replace: true });
//             window.location.reload();
//           }
//         }
//       } else {
//         console.log("entering here in new tut id");
//         let exmId = tutorId + "_1";
//         const get_subjects = await axiosClient.get(
//           "https://testapis4.el.r.appspot.com/api/tutor/get_subjects"
//         );
//         console.log({ get_subjects });
//         if (get_subjects) {
//           console.log(get_subjects?.data?.subVal, "🥲🥲<>");
//           setSubList(get_subjects?.data?.subVal);
//           setExamId(exmId);
//           setLoading(false);
//         }
//       }
//     };
//     findForm2();
//   }, [tutorId, history, location, tutStatusUpdate]);

//   const SelectedSub = (e) => {
//     setSelectedSub(e, "eeeeeee");
//     dispatch(setSelectedSubject(e));
//   };

//   const CurrentBase64_func = (val) => {
//     console.log({ valbase64: val });
//     setCurrentBase64(val);
//   };

//   const key_func = (value) => {
//     setKeyArSend(value);
//   };
  
//   const setResult_func = (value) => {
//     setResult(value);
//     dispatch(setResultData(value));
//   };

//   const setResultStatus_func = (value) => {
//     console.log(value, "in exam end");
//     setResultStatus(value);
//     dispatch(setTutorMark(value));
//   };

//   const setSubject_func = (value) => {
//     setSubject(value);
//     console.log({ subject });
//   };

//   const setLocalSt = (temp_tutorObj) => {
//     let tutor_stringified = JSON.stringify(temp_tutorObj);
//     localStorage.setItem("tutor", tutor_stringified);
//   };

//   return (
//     <Fragment>
//       <Routes>
//         <Route
//           path=""
//           element={
//             loading ? (
//               <div style={{ marginLeft: "45%", marginTop: "20%" }}>
//                 <Puff
//                   heigth="100"
//                   width="100"
//                   color="#01b1b1"
//                   ariaLabel="loading"
//                 />
//               </div>
//             ) : (
//               <TutorExamEntrance
//                 subList={subList}
//                 SelectedSub={SelectedSub}
//                 CurrentBase64_func={CurrentBase64_func}
//                 key_func={key_func}
//                 setTimeOfTest={setTimeOfTest}
//                 setLocalSt={setLocalSt}
//               />
//             )
//           }
//         />
//         <Route
//           path="sheet"
//           element={
//             <TutorExam
//               subjectList={selectedSub}
//               currentBase64={currentBase64}
//               keyArSend={keyArSend}
//               setResult_func={setResult_func}
//               setResultStatus_func={setResultStatus_func}
//               timeOfTest={timeOfTest}
//               setSubject_func={setSubject_func}
//               examId={examId}
//               tutorId={tutorId}
//               setLocalSt={setLocalSt}
//             />
//           }
//         />
//         <Route
//           path="subjective_sheet"
//           element={
//             <SubjectiveDemo
//               examId={examId}
//               tutorId={tutorId}
//               subjectList={selectedSub}
//             />
//           }
//         />
//         <Route
//           path="terms_condition"
//           element={
//             <SubjectiveTestComponent
//               examId={examId}
//               tutorId={tutorId}
//               result={result}
//               resultStatus={resultStatus}
//               subjectList={selectedSub}
//             />
//           }
//         />
//         <Route
//           path="submitted"
//           element={
//             <TutorExamEnd
//               subject={selectedSub}
//               result={result}
//               resultStatus={resultStatus}
//               examId={examId}
//             />
//           }
//         />
//         <Route
//           path="subjective_result"
//           element={
//             <SubjectiveResult
//               subject={selectedSub}
//               examId={examId}
//               tutorId={tutorId}
//             />
//           }
//         />
//       </Routes>
//     </Fragment>
//   );
// };

// export default TutorExamAppWrapper;


import React, { Fragment, useState, useEffect } from "react";
import { axiosClient } from "../../../utils/auth.util";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Puff } from "react-loader-spinner";

/*------ Pages-----*/
import Header from "../Components/dashboard-navbar";
import TutorExam from "../Pages/tutor_exam/TutorExam";
import TutorExamEntrance from "../Pages/tutor_exam/TutorExamEntrance";
import TutorExamEnd from "../Pages/tutor_exam/TutorExamEnd";
import TutorExamEndDialog from "../Pages/tutor_exam/TutorExamEndDialog";
import SubjectiveDemo from "../Pages/tutor_exam/SubjectiveDemo.jsx";
import SubjectiveTestComponent from "../Pages/tutor_exam/TutorTermsAndCondition.jsx";
import SubjectiveResult from "../Pages/tutor_exam/SubjectiveResult.jsx";

import {
  setResultData,
  setSelectedSubject,
  setExamId,
  setTutorMark,
  setExamObj,
} from "../../../redux/slice/tutorExamSlice";

const TutorExamAppWrapper = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // Get data from Redux instead of localStorage
  const userData = useSelector(state => state.register.userData);
  const authToken = useSelector(state => state.register.authToken);
  const examObj = useSelector((state) => state.exam.examObj);

  const [subList, setSubList] = useState([]);
  const [selectedSub, setSelectedSub] = useState([]);
  const [currentBase64, setCurrentBase64] = useState([]);
  const [keyArSend, setKeyArSend] = useState([]);
  const [subject, setSubject] = useState();
  const [resultStatus, setResultStatus] = useState();
  const [result, setResult] = useState();
  const [examId, setExamId] = useState();
  const [tutStatusVal, setTutStatusVal] = useState();
  const [timeOfTest, setTimeOfTest] = useState();
  const [tutStatusUpdate, setTutStatusUpdate] = useState(false);
  const [loading, setLoading] = useState(true);

  // Get tutorId from Redux userData
  const tutorId = userData?._id || userData?.tutor_id || `USER_${Date.now()}`;

  console.log("✌️examObj --->", examObj);

  useEffect(() => {
    const findForm2 = async () => {
      if (!userData || !tutorId) {
        setLoading(false);
        return;
      }

      try {
        const find_examId = await axiosClient.post("/tutorweb/find_examId", {
          tutorId: tutorId,
        });

        console.log({ debug_tutorId: find_examId });

        if (find_examId?.data?.success === true) {
          let exmId = find_examId?.data?.examId?.split("_")[1];
          let newId = +exmId + 1;
          let newId2 = tutorId + "_" + newId;
          let get_subject_updated = [];

          setTutStatusVal(find_examId.data.tutStatus);

          const get_subjects = await axiosClient.get(
            "https://testapis4.el.r.appspot.com/api/tutor/get_subjects"
          );

          if (get_subjects) {
            let retestTrueSubjects = new Set();
            get_subject_updated = get_subjects?.data?.subVal;

            //storing subjects with retest true
            find_examId?.data?.tutor_exam?.forEach((el) => {
              get_subject_updated?.forEach((el2) => {
                if (el2[0] === el.subject) {
                  if (el?.retest === true) {
                    retestTrueSubjects.add(el.subject);
                  } else {
                    retestTrueSubjects.delete(el.subject);
                  }
                }
              });
            });

            //filtering already written subjects
            get_subject_updated = await get_subject_updated?.filter((el2) => {
              return !find_examId?.data?.tutor_exam.some(
                (el) => el.subject === el2[0]
              );
            });

            console.log({ retestTrueSubjects, get_subject_updated });

            //pushing retest true
            retestTrueSubjects.forEach((eachSub) =>
              get_subject_updated.push([eachSub])
            );

            setSubList(get_subject_updated);
            setExamId(newId2);
            setLoading(false);
          }

          if (find_examId.data.lastExamId) {
            if (
              find_examId.data.tutStatus === "mcqe" &&
              location.pathname !== "/register-dashboard/tutor_exam/submitted"
            ) {
              history("/register-dashboard/tutor_exam/submitted", { replace: true });
              window.location.reload();
            } else if (
              find_examId.data.tutStatus === "subs" &&
              location.pathname !== "/register-dashboard/tutor_exam/subjective_sheet"
            ) {
              history("/register-dashboard/tutor_exam/subjective_sheet", { replace: true });
              window.location.reload();
            } else if (
              find_examId.data.tutStatus === "sube" &&
              location.pathname !== "/register-dashboard/tutor_exam/subjective_result"
            ) {
              history("/register-dashboard/tutor_exam/subjective_result", { replace: true });
              window.location.reload();
            }
          }
        } else {
          console.log("entering here in new tut id");
          let exmId = tutorId + "_1";
          const get_subjects = await axiosClient.get(
            "https://testapis4.el.r.appspot.com/api/tutor/get_subjects"
          );

          console.log({ get_subjects });
          if (get_subjects) {
            console.log(get_subjects?.data?.subVal, "🥲🥲<>");
            setSubList(get_subjects?.data?.subVal);
            setExamId(exmId);
            setLoading(false);
          }
        }
      } catch (error) {
        console.error("Error in findForm2:", error);
        setLoading(false);
      }
    };

    findForm2();
  }, [tutorId, history, location, tutStatusUpdate, userData]);

  const SelectedSub = (e) => {
    setSelectedSub(e, "eeeeeee");
    dispatch(setSelectedSubject(e));
  };

  const CurrentBase64_func = (val) => {
    console.log({ valbase64: val });
    setCurrentBase64(val);
  };

  const key_func = (value) => {
    setKeyArSend(value);
  };

  const setResult_func = (value) => {
    setResult(value);
    dispatch(setResultData(value));
  };

  const setResultStatus_func = (value) => {
    console.log(value, "in exam end");
    setResultStatus(value);
    dispatch(setTutorMark(value));
  };

  const setSubject_func = (value) => {
    setSubject(value);
    console.log({ subject });
  };

  return loading ? (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "20%" }}>
      <Puff color="#00BFFF" height={100} width={100} />
    </div>
  ) : (
    <Fragment>
      <Routes>
        <Route
          path=""
          element={
            <TutorExamEntrance
              subList={subList}
              SelectedSub={SelectedSub}
              selectedSub={selectedSub}
              CurrentBase64_func={CurrentBase64_func}
              key_func={key_func}
              userData={userData}
              tutorId={tutorId}
              examId={examId}
            />
          }
        />
        <Route
          path="test"
          element={
            <TutorExam
              subjectList={selectedSub}
              currentBase64={currentBase64}
              keyArSend={keyArSend}
              timeOfTest={timeOfTest}
              setResult_func={setResult_func}
              setResultStatus_func={setResultStatus_func}
              setSubject_func={setSubject_func}
              userData={userData}
              tutorId={tutorId}
              examId={examId}
            />
          }
        />
        <Route
          path="submitted"
          element={
            <TutorExamEnd
              result={result}
              resultStatus={resultStatus}
              subject={subject}
              examId={examId}
              userData={userData}
            />
          }
        />
        <Route
          path="subjective_sheet"
          element={
            <SubjectiveTestComponent
              userData={userData}
            />
          }
        />
        <Route
          path="subjective_result"
          element={
            <SubjectiveResult
              userData={userData}
            />
          }
        />
      </Routes>
    </Fragment>
  );
};

export default TutorExamAppWrapper;
